import { i18n } from '@/commons/utils';

function dateFormat(date) {
  return window.moment(new Date(date)).format(window.Messages('delivery.RelayPoint.date.format'));
  // TODO return window.moment(date).format('product.price.output');
}

function i18nExists(key) {
  return (i18n(key) !== '' && i18n(key) !== key);
}

function getValue(val, defaultVal) {
  if (val || val === false || val === 0 || val === '') return val;
  return defaultVal;
}

export function init(node, resp) {
  const priceFormatterInfos = window.pricePattern ? window.pricePattern : Cube.priceConfig;

  /* PRICE PARAMS */
  // ---------------
  const priceCustomParams = node.dataset.priceCustomParams ? JSON.parse(node.dataset.priceCustomParams) : {};

  priceCustomParams.showEcofeeText = getValue(priceCustomParams.showEcofeeText, true);
  priceCustomParams.showPriceDropText = getValue(priceCustomParams.showPriceDropText, true);
  priceCustomParams.showRecommendedPriceText = getValue(priceCustomParams.showRecommendedPriceText, true);
  priceCustomParams.showTvaText = getValue(priceCustomParams.showTvaText, true);
  priceCustomParams.showSalesDateText = getValue(priceCustomParams.showSalesDateText, cube.config.feature_displaySalesTypeInformation === 'true');
  priceCustomParams.showPricePerUnitText = getValue(priceCustomParams.showPricePerUnitText, true);
  priceCustomParams.priceFormat = getValue(priceCustomParams.priceFormat, 'default');
  priceCustomParams.lightPriceFormat = getValue(priceCustomParams.lightPriceFormat, 'light');
  priceCustomParams.insideATag = getValue(priceCustomParams.insideATag, false);
  priceCustomParams.forceFootnoteMarker = getValue(priceCustomParams.forceFootnoteMarker, false);
  priceCustomParams.showFootnoteMarker = getValue(priceCustomParams.showFootnoteMarker, false);

  const isServiceProduct = node.dataset.productType === 'service';
  const isGiftcardProduct = node.dataset.productType === 'giftcard';
  const showDiscountPercentage = resp.displayDiscountPercentage && resp.discountPercentage > 0;
  const showFromInPriceReduction = priceFormatterInfos.reduction.showFrom;
  const showPriceDropText = resp.dropPriceValue && i18nExists('product.price.drop.details') && !resp.onSale && priceCustomParams.showPriceDropText;
  const showRecommendedPriceText = resp.recommendedStandardPrice && i18nExists('product.price.recommended') && priceCustomParams.showRecommendedPriceText;
  const {showTvaText} = priceCustomParams;
  const showSalesDateText = priceCustomParams.showSalesDateText && resp.onSale;
  const {insideATag} = priceCustomParams;
  const {showFootnoteMarker} = priceCustomParams;
  const showPricePerUnitText = cube.$(`[data-unit-price-identifier="${resp.skuId}"]`) && i18nExists('pdm.view.quantity.price');

  /* Next 2 will return false, we need several evolutions in order to use them : */

  const showEcofeeText = resp.ecofee && i18nExists('product.price.ecofee') && priceCustomParams.showEcofeeText;
  // -> as of now, resp.ecofee is not returned by pricing api --> Returns false

  const pricePatternSuffix = (!showFromInPriceReduction && resp.showFrom) ? 'WithFrom' : '';
  const value               = resp.value || resp.activePrice;
  const from                = resp.showFrom;
  const percent             = resp.discountPercentage;
  const oldPrice            = cube.priceFormatter(resp.listPrice, priceFormatterInfos, priceCustomParams.lightPriceFormat);
  const price               = cube.priceFormatter(value, priceFormatterInfos, `${priceCustomParams.priceFormat + pricePatternSuffix}`);

  /* END OF PRICE PARAMS */
  // ----------------------


  /* ADD-ONS ELEMENTS BUILDERS */
  // ----------------------------


  // Top addon
  let topAddon = ``;

  if(isGiftcardProduct){
    topAddon += `<span class="dkt-price__info-addon dkt-price__from">${i18n('product.startingat.label')}</span>`;
  } else {
    if (showFromInPriceReduction && from && resp.onSale) {
      topAddon += `<span class="dkt-price__info-addon">`;
    }

    if (showFromInPriceReduction && from) {
      if (!resp.onSale) {
        topAddon += `<span class="dkt-price__info-addon dkt-price__from">${i18n('product.price.label')}</span>`;
      } else {
        topAddon += `${i18n('product.price.label')} `;
      }
    }

    if (resp.onSale) {
      if(!(showFromInPriceReduction && from)){
        topAddon += `<span class="dkt-price__info-addon"> `;
      }
      topAddon += `<span class="dkt-price__previous-price">${oldPrice}</span> `;
      if(showDiscountPercentage) {
        topAddon += `<span class="dkt-price__reduction">-${percent}%</span> `;
      }
      if(!(showFromInPriceReduction && from)){
        topAddon += `</span>`;
      }
    }

    if (showFromInPriceReduction && from && resp.onSale) {
      topAddon += `</span>`;
    }
  }


  // Foot note marker
  const displayFootnoteMarker = `
    <sup class="dkt-price__footnote-marker">
      ${i18n('product.price.footnoteMarker')}
    </sup>`;


  // Price drop
  const displayPriceDrop = `
    <span class="dkt-price__info-addon dkt-price__price-drop">
      <span class="dkt-price__price-drop-title">${i18n('product.price.drop.title')}</span>
      ${i18n('product.price.drop.details', cube.priceFormatter(resp.dropPriceValue, priceFormatterInfos, priceCustomParams.lightPriceFormat), dateFormat(resp.dropPriceDate, 'product.price.output'))}
    </span>`;


  // Recommended price
  const displayRecomendedPrice = `
    <span class="dkt-price__info-addon dkt-price__price-reco">
      <span class="dkt-price__price-reco-title">${i18n('product.price.recommended.title')}</span>
      ${i18n('product.price.recommended', cube.priceFormatter(resp.recommendedStandardPrice, priceFormatterInfos, priceCustomParams.lightPriceFormat))}
    </span>`;


  // Tva -- This is a placeholder
  let tvaI18n = i18n('pdm.product.price.tva.classicProduct');
  if (isGiftcardProduct) tvaI18n = i18n('pdm.product.price.tva.giftCard');
  else if (isServiceProduct) tvaI18n = i18n('pdm.product.price.tva.serviceProduct');
  if (insideATag) tvaI18n = tvaI18n.replace(/<a/g, '<span').replace(/<\/a>/g, '</span>');

  const displayTvaText = `<span class="dkt-price__legal-addon">${i18n('product.price.footnoteMarker')} ${tvaI18n}</span>`;


  // Sales type & date
  let displaySalesType = ``;

  // The promo has a start date and/or a end date
  if(['day.to.day', 'dayToDay'].indexOf(resp.salesType) >= 0){
    if(resp.startDate && resp.endDate && i18n('price.sales.type.day.to.day.start.end.date')){
      displaySalesType += `<span class="dkt-price__legal-addon">${i18n('price.sales.type.day.to.day.start.end.date', dateFormat(resp.startDate, 'product.sales.price.output'), dateFormat(resp.endDate, 'product.sales.price.output'))}</span>`;
    }
    if(resp.startDate && !resp.endDate && i18n('price.sales.type.day.to.day.start.date')){
      displaySalesType += `<span class="dkt-price__legal-addon">${i18n('price.sales.type.day.to.day.start.date', dateFormat(resp.startDate, 'product.sales.price.day.to.day.discount.output'))}</span>`;
    }
    if(!resp.startDate && resp.endDate && i18n('price.sales.type.day.to.day.end.date')){
      displaySalesType += `<span class="dkt-price__legal-addon">${i18n('price.sales.type.day.to.day.end.date', dateFormat(resp.endDate, 'product.sales.price.output'))}</span>`;
    }
  }

  // The promo ends when out of stock
  if(['end.of.line', 'endOfLine'].indexOf(resp.salesType) >= 0){
    displaySalesType += `<span class="dkt-price__legal-addon">${i18n('price.sales.type.endOfLine', dateFormat(resp.startDate, 'product.sales.price.output'))}</span>`;
  }

  // The promo last until sales period
  if(['seasonal.sale', 'seasonalSale'].indexOf(resp.salesType) >= 0){
    displaySalesType += `<span class="dkt-price__legal-addon">${i18n('price.sales.type.seasonal.sale', dateFormat(resp.startDate, 'product.sales.price.output'))}</span>`;
  }


  // Price per unit -- This is a placeholder dataset.unitPriceReference
  const referenceNode = cube.$(`[data-unit-price-identifier="${resp.skuId}"]`);
  const displayPricePerUnitText = referenceNode && referenceNode.dataset.unitPrice && referenceNode.dataset.unitOfMeasure ?
    `<span class="dkt-price__legal-addon">
      ${i18n('pdm.view.quantity.price', cube.priceFormatter(referenceNode.dataset.unitPrice, priceFormatterInfos, priceCustomParams.lightPriceFormat), referenceNode.dataset.unitOfMeasure)}
    </span>` : '';

    /* END OF ADD-ONS ELEMENTS BUILDERS */
  // -----------------------------------



  /* WRAP UP & RENDER */
  // -------------------

  const priceContainer = `
    ${topAddon}

    ${showEcofeeText ? `<div class="dkt-price__ecofee-container">` : ``}
    <div class="dkt-price__cartridge" data-price="${value}">
      ${price}
      ${showFootnoteMarker ? displayFootnoteMarker : ``}
    </div>
    ${showEcofeeText ? `<span class="dkt-price__legal-addon">${i18n('product.price.ecofee', cube.priceFormatter(resp.ecofee, priceFormatterInfos, priceCustomParams.lightPriceFormat))}</span>
    </div>` : ``}

    ${showPriceDropText ? displayPriceDrop : ``}

    ${showRecommendedPriceText ? displayRecomendedPrice : ``}

    ${showTvaText ? displayTvaText : ``}

    ${showSalesDateText ? displaySalesType : ``}

    ${showPricePerUnitText ? displayPricePerUnitText : ``}
  `;

  if (resp.onSale) node.classList.add('dkt-price--promo');
  else node.classList.remove('dkt-price--promo');

  node.innerHTML = priceContainer;

  /* END OF WRAP UP & RENDER */
  // --------------------------

};



// WEBPACK FOOTER //
// ./src/commons/component/price/price-builder.js